import { useLocation, useOutlet } from "react-router-dom";
import { AnimatePresence, motion } from "framer-motion";
import { TopBar } from "@/components/layout/TopBar";
import { Navbar } from "@/components/layout/Navbar";
import { Footer } from "@/components/layout/Footer";
import { useCmsDocument } from "@/cms/CmsContentProvider";

export const Layout = () => {
  const location = useLocation();
  const { runtimeKey } = useCmsDocument();
  // Snapshot the matched route element so the OUTGOING page keeps rendering its
  // own content during the exit animation. Rendering <Outlet/> directly would
  // re-resolve to the new route immediately and flash before the exit finishes.
  const outlet = useOutlet();
  return (
    <div className="flex min-h-screen flex-col" data-content-version={runtimeKey}>
      {/* The animated brand pattern is no longer a single fixed layer (opaque
          section backgrounds painted over it and hid it). Instead each light
          section mounts its own <BrandPatternLayer/> above its background but
          below content — see BrandPatternLayer.jsx. */}
      <TopBar />
      <Navbar />
      <main className="flex-1">
        {/* Short, elegant fade between pages. initial={false} keeps the very
            first load instant so the hero animations play cleanly. */}
        <AnimatePresence mode="wait" initial={false}>
          <motion.div
            key={location.pathname}
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 0.45, ease: "easeInOut" }}
          >
            {outlet}
          </motion.div>
        </AnimatePresence>
      </main>
      <Footer />
    </div>
  );
};
